import { getCurrentInstance } from 'vue';

import { AUTOMATION_DIRECTIVE_ATTRIBUTE } from '@/plugins/AutomationPlugin';
import { isTestingEnv } from '@modules/core/services/env-config/utils/envConfig';

export interface QaAutoIdComposable {
  getQaAutoIdAttribute(): Record<string, string> | null;
  qaAutoIdAttributeName: string;
}

export default function useQaAutoId(): QaAutoIdComposable {
  const qaAutoIdAttributeName = AUTOMATION_DIRECTIVE_ATTRIBUTE;

  const getQaAutoIdAttribute = (): Record<string, string> | null => {
    const componentName = getCurrentInstance()?.type.__name || '';
    return isTestingEnv() && componentName ? { [AUTOMATION_DIRECTIVE_ATTRIBUTE]: componentName } : null;
  };

  return {
    qaAutoIdAttributeName,
    getQaAutoIdAttribute,
  };
}
